<div class="main">
    <!-- Section 1 -->
    <div class="section1" fxHide.lt-sm>
        <img src="../../../../assets/images/coin.png" alt="" class="coin">
        <div class="titleDiv">
            <div class="title">
                <h1 class="mainTitle">{{mainTitle}}</h1>
                <div class="titleDescription">
                    <p>{{mainTitleDescription}}</p>
                </div>
            </div>
        </div>
        <img src="../../../../assets/images/coin.png" alt="" class="coin">
    </div>
    <!-- Mobile view -->
    <div class="section1" fxHide.gt-xs>
        <div class="title">
            <img src="../../../../assets/images/coin.png" alt="" class="coin">
            <h1 class="mainTitle">{{mainTitle}}</h1>
            <img src="../../../../assets/images/coin.png" alt="" class="coin">
        </div>
        <div class="titleDescription">
            <p>{{mainTitleDescription}}</p>
        </div>
    </div>
    <!-- Section 2 -->
    <div class="section2">
        <div class="secMainHeader blueColor">
            <h1 class="sectionHeader">{{section2Heading}}</h1>
            <div class="headerDescription">{{section2Description}}</div>
        </div>
        <div class="perkCards" fxLayout="row wrap" fxLayout.lt-sm="column" fxFlex.lt-sm="100%">
            <div class="card" *ngFor="let card of perkcards"  fxFlex.lt-sm="100%" fxFlex.gt-xs="18%">
                <img [src]="card.image" alt="" class="cardImage">
                <div class="cardTitle">{{card.title}}</div>
                <div class="cardDescription">{{card.sub_title}}</div>
            </div>
        </div>
    </div>
    <!-- Section 3 -->
    <div class="section3">
        <div class="secMainHeader greyColor">
            <h1 class="sectionHeader">{{section3Heading}}</h1>
            <div class="headerDescription">{{section3Description}}</div>
        </div>
        <div class="image-container">
            <img src="../../../../assets/images/getCurrency.png" alt="How to Get Currency Image" 
                class="centered-image" fxHide.lt-sm>
            <img src="../../../../assets/images/getCurrencyMobile.png" alt="How to Get Currency Image" 
                class="centered-image" fxHide.gt-xs>
            <!-- Box 1 -->
            <div class="box box1" *ngIf="cards?.length > 0" >
                <h1 class="boxHeading">{{cards[0].title}}</h1>
                <p class="boxDescription" fxHide.lt-sm>{{cards[0].sub_title}}</p>
                <button class="boxButton" 
                    style="background-color: #F14925;" 
                    (click)="openDialog(boxDialog, cards[0],'#F14925')">
                    More Info
                </button>
            </div>
            <!-- Box 2 -->            
            <div class="box box2" *ngIf="cards?.length > 0" >
                <h1 class="boxHeading">{{cards[1].title}}</h1>
                <p class="boxDescription" fxHide.lt-sm>{{cards[1].sub_title}}</p>
                <button class="boxButton" 
                    style="background-color: #FC8010;" 
                    (click)="openDialog(boxDialog, cards[1],'#FC8010')">
                    More Info
                </button>
            </div>
            <!-- Box 3 -->
            <div class="box box3" *ngIf="cards?.length > 0" >
                <h1 class="boxHeading">{{cards[2].title}}</h1>
                <p class="boxDescription" fxHide.lt-sm>{{cards[2].sub_title}}</p>
                <button class="boxButton" 
                    style="background-color: #2ECAD2;" 
                    (click)="openDialog(boxDialog, cards[2],'#2ECAD2')">
                    More Info
                </button>
            </div>
            <!-- Earlier Figma option -->
             <!-- box 1 -->
              <!-- <div class="box box1" fxHide.lt-sm>
                <h1 class="boxHeading">{{box1.title}}</h1>
                <p class="boxDescription" >{{box1.sub_title}}</p>
                <button class="boxButton" 
                    style="background-color: #F14925;" 
                    (click)="openDialog(boxDialog, box1,'#F14925')">
                    More Info
                </button>
            </div> -->
            <!-- <div class="box box1" fxHide.gt-xs (click)="openDialog(boxDialog, box1,'#F14925')">
                <h1 class="boxHeading">{{box1.title}}</h1>
            </div> -->
             <!-- box 2 -->
              <!-- <div class="box box2" fxHide.lt-sm>
                <h1 class="boxHeading">{{box2.title}}</h1>
                <p class="boxDescription">{{box2.sub_title}}</p>
                <button class="boxButton" 
                    style="background-color: #FC8010;" 
                    (click)="openDialog(boxDialog, box2, '#FC8010')">
                    More Info
                </button>
            </div>
            <div class="box box2" fxHide.gt-xs (click)="openDialog(boxDialog, box2, '#FC8010')">
                <h1 class="boxHeading">{{box2.title}}</h1>
            </div> -->
             <!-- Box 3 -->
            <!-- <div class="box box3" fxHide.lt-sm>
                <h1 class="boxHeading">{{box3.title}}</h1>
                <p class="boxDescription">{{box3.sub_title}}</p>
                <button class="boxButton" 
                    style="background-color: #2ECAD2;" 
                    (click)="openDialog(boxDialog, box3, '#2ECAD2')">
                    More Info
                </button>
            </div>
            <div class="box box3" fxHide.gt-xs (click)="openDialog(boxDialog, box3, '#2ECAD2')">
                <h1 class="boxHeading">{{box3.title}}</h1>
            </div> -->
            <!--  -->
        </div>
    </div>
    <!-- Section 4 -->
    <div class="section4">
        <div class="secMainHeader">
            <h1 class="sectionHeader">{{section4Heading}}</h1>
        </div>
        <div class="steps">
            <div class="stepCard" 
                *ngFor="let step of steps; let i = index"
                [fxLayout.gt-xs]="i % 2 === 0 ? 'column' : 'column-reverse'"
                [fxLayout.lt-sm]="i % 2 === 0 ? 'row' : 'row-reverse'"
                fxFlex.gt-xs="33%"
                fxLayoutAlign="start center">
                <div class="stepInfo" fxLayout="column" fxLayoutAlign="start center">
                    <div class="stepInfoHeader" fxLayout>
                        <div class="stepNumber">{{i + 1}}</div>
                        <div class="stepTitle">{{step.title}}</div>
                    </div>
                    <div class="stepInfoDescription">{{step.sub_title}}</div>
                </div>
                <div class="stepImage">
                    <img [src]="step.image" alt="">
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Dialog -->
<ng-template #boxDialog let-dialogRef>
    <div class="dialogDiv" 
        [ngStyle]="{'background-color': 'white', 'border': '10px solid ' + boxColor}">
      <i (click)="close()" 
        style="font-size: 22px; cursor: pointer;" 
        [ngStyle]="{'color': boxColor}"
        class="bi bi-x-circle closeBtn"></i>
      <h1 mat-dialog-title 
        class="dialogTitle"
        [ngStyle]="{'color': boxColor}">
        {{dialogData.title}}
      </h1>
      <div mat-dialog-content 
        style="display: flex; justify-content: center; width: 80%;" 
        class="dialogDescription">
        <p [ngStyle]="{'color': boxColor}" [innerHTML]="dialogData.description" style="font-size: 16px;"></p>
      </div>
    </div>
  </ng-template>
  